export default function Tick() {
  return (
    <svg
      class="andes-badge__icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
    >
      <g fill="#ffffff">
        <g>
          <path
            d="M5 6.586L3.586 8 7 11.414 12.414 6 11 4.586l-4 4z"
            class="andes-badge__icon-inner"
          ></path>
        </g>
      </g>
    </svg>
  );
}
